import type { GameRules } from "whole-shared";

import { ClientDevSpearheadGameRule } from "./ClientDevSpearheadGameRule";
import { ClientSpearheadGameRule } from "./ClientSpearheadGameRule";

export * from "./Ability";
export * from "./ClientDevSpearheadGameRule";
export * from "./ClientGameRule";
export * from "./ClientSpearheadGameRule";

export const ClientGameRules: GameRules<false> = {
  aos4sh:   ClientSpearheadGameRule,
  d_aos4sh: ClientDevSpearheadGameRule
};
